import {VehicleReservations} from '@dms/shared';

import {useRequiredParams} from 'shared/web';

export function Reservations() {
  const {id: vehicleId} = useRequiredParams();

  return <VehicleReservations vehicleId={vehicleId} />;
}
